// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.components-Filters-styles___filtersContainer--K3PJs {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
}

  .components-Filters-styles___filtersContainer--K3PJs .components-Filters-styles___input--ZX7ue {
    margin: 0 8px;
  }

  @media only screen and (min-width: 1024px) {
    .components-Filters-styles___filtersContainer--K3PJs .components-Filters-styles___places--wJt4G {
      flex: 300px 1 0;
    }

    .components-Filters-styles___filtersContainer--K3PJs .components-Filters-styles___dates--A1ZJW {
      flex: 200px 1 0;
    }

    .components-Filters-styles___filtersContainer--K3PJs .components-Filters-styles___button--eRov6 {
      flex: 216px 1 0;
    }
  }

  @media only screen and (min-width: 1440px) {
    .components-Filters-styles___filtersContainer--K3PJs .components-Filters-styles___places--wJt4G {
      flex: 446px 1 0;
    }

    .components-Filters-styles___filtersContainer--K3PJs .components-Filters-styles___dates--A1ZJW {
      flex: 299px 1 0;
    }

    .components-Filters-styles___filtersContainer--K3PJs .components-Filters-styles___button--eRov6 {
      flex: 341px 1 0;
    }
  }

.components-Filters-styles___filterInput--nA3Jt {
  margin-left: 8px;
  padding: 8px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  flex: 1;
}

.components-Filters-styles___filterSelect--s9U9v {
  margin-left: 8px;
  padding: 8px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  flex: 1;
}

.components-Filters-styles___filterLabel--n9XCU {
  font-weight: bold;
}

.components-Filters-styles___filterControl--GriEh {
  width: 100%
}`, "",{"version":3,"sources":["webpack://./components/Filters/styles.pcss"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AAiCf;;EA/BE;IACE,aAAa;EACf;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;AAGF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;AACF","sourcesContent":["\n.filtersContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n\n  .input {\n    margin: 0 8px;\n  }\n\n  @media only screen and (min-width: 1024px) {\n    .places {\n      flex: 300px 1 0;\n    }\n\n    .dates {\n      flex: 200px 1 0;\n    }\n\n    .button {\n      flex: 216px 1 0;\n    }\n  }\n\n  @media only screen and (min-width: 1440px) {\n    .places {\n      flex: 446px 1 0;\n    }\n\n    .dates {\n      flex: 299px 1 0;\n    }\n\n    .button {\n      flex: 341px 1 0;\n    }\n  }\n}\n\n.filterInput {\n  margin-left: 8px;\n  padding: 8px 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  flex: 1;\n}\n\n.filterSelect {\n  margin-left: 8px;\n  padding: 8px 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  flex: 1;\n}\n\n.filterLabel {\n  font-weight: bold;\n}\n\n.filterControl {\n  width: 100%\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filtersContainer": `components-Filters-styles___filtersContainer--K3PJs`,
	"input": `components-Filters-styles___input--ZX7ue`,
	"places": `components-Filters-styles___places--wJt4G`,
	"dates": `components-Filters-styles___dates--A1ZJW`,
	"button": `components-Filters-styles___button--eRov6`,
	"filterInput": `components-Filters-styles___filterInput--nA3Jt`,
	"filterSelect": `components-Filters-styles___filterSelect--s9U9v`,
	"filterLabel": `components-Filters-styles___filterLabel--n9XCU`,
	"filterControl": `components-Filters-styles___filterControl--GriEh`
};
module.exports = ___CSS_LOADER_EXPORT___;
